import { ERROR_CODES, METHOD_STATUSES } from "@modules/sdk/constants";
import {
    checkRequiredArguments,
    checkSubscribers,
    promiseWithTimeout,
} from "@modules/sdk/helpers";
import SdkError from "@modules/sdk/methods/SdkError";
import SdkMethodsCollector from "@modules/sdk/methods/SdkMethodsCollector";
import { SdkMethodsInterface } from "@modules/sdk/methods/SdkMethodsInterface";
import { Success } from "@modules/sdk/types";

import { WISHLISTS_SDK_METHODS } from "./constants";
import CloseWishlistsDrawerSdkMethodPayload from "./methods/CloseWishlistsDrawerSdkMethodPayload";
import CreateWishlistItemSdkMethodPayload from "./methods/CreateWishlistItemSdkMethodPayload";
import DeleteWishlistItemSdkMethodPayload from "./methods/DeleteWishlistItemSdkMethodPayload";
import OpenWishlistsDrawerSdkMethodPayload from "./methods/OpenWishlistsDrawerSdkMethodPayload";

class WishlistsSdkMethods
    implements SdkMethodsInterface<WISHLISTS_SDK_METHODS>
{
    constructor(private readonly _collector: SdkMethodsCollector) {}

    public openWishlistsDrawer() {
        return promiseWithTimeout(
            new Promise<Success>((resolve, reject) => {
                checkSubscribers(
                    WISHLISTS_SDK_METHODS.OPEN_WISHLISTS_DRAWER,
                    reject
                );

                this._collector.notifySubscribers(
                    new OpenWishlistsDrawerSdkMethodPayload(() =>
                        resolve({ status: METHOD_STATUSES.SUCCESS })
                    )
                );
            })
        );
    }

    public closeWishlistsDrawer() {
        return promiseWithTimeout(
            new Promise<Success>((resolve, reject) => {
                checkSubscribers(
                    WISHLISTS_SDK_METHODS.CLOSE_WISHLISTS_DRAWER,
                    reject
                );

                this._collector.notifySubscribers(
                    new CloseWishlistsDrawerSdkMethodPayload(() =>
                        resolve({ status: METHOD_STATUSES.SUCCESS })
                    )
                );
            })
        );
    }

    public createWishlistItem(
        productId: number,
        variantId: number,
        wishlistId?: number
    ) {
        return promiseWithTimeout(
            new Promise<Success>((resolve, reject) => {
                checkRequiredArguments(
                    WISHLISTS_SDK_METHODS.CREATE_WISHLIST_ITEM,
                    1,
                    arguments.length,
                    reject
                );

                checkSubscribers(
                    WISHLISTS_SDK_METHODS.CREATE_WISHLIST_ITEM,
                    reject
                );

                this._collector.notifySubscribers(
                    new CreateWishlistItemSdkMethodPayload(
                        productId,
                        variantId,
                        wishlistId || null,
                        () => resolve({ status: METHOD_STATUSES.SUCCESS }),
                        () => reject(new SdkError(ERROR_CODES.GENERAL_ERROR))
                    )
                );
            })
        );
    }

    public deleteWishlistItem(
        productId: number,
        variantId?: number,
        wishlistId?: number
    ) {
        return promiseWithTimeout(
            new Promise<Success>((resolve, reject) => {
                checkRequiredArguments(
                    WISHLISTS_SDK_METHODS.DELETE_WISHLIST_ITEM,
                    1,
                    arguments.length,
                    reject
                );

                checkSubscribers(
                    WISHLISTS_SDK_METHODS.DELETE_WISHLIST_ITEM,
                    reject
                );

                this._collector.notifySubscribers(
                    new DeleteWishlistItemSdkMethodPayload(
                        productId,
                        variantId || null,
                        wishlistId || null,
                        () => resolve({ status: METHOD_STATUSES.SUCCESS }),
                        () => reject(new SdkError(ERROR_CODES.GENERAL_ERROR))
                    )
                );
            })
        );
    }
}

export default WishlistsSdkMethods;
